import MainGame from "./index.vue";

export default {
  path: "game",
  name: "MainGame",
  component: MainGame,
  meta: {
    label: "游戏管理",
  },
};
